import { IDealSourceData } from 'modules/core/types/dealSource';

/**
 * A deal-source vehicle is created manually when RouteOne/Dealertrack reports it without the
 * required info, and the user supplies the missing Book Value / Retail Price in the "Vehicle
 * Missing Required Information" modal. The deal source has no record of those values, so every
 * refetch — one fires on each navigation between the RAC and SBB+/SBC+ pages — reports them
 * missing again and re-opens the modal (SWA-7941). Carry them over instead: whatever the deal
 * source does report still wins.
 */
export const preserveManuallyEnteredVehicleInfo = (
  previous: IDealSourceData | undefined,
  next: IDealSourceData,
): IDealSourceData => {
  const isSameManuallyCreatedVehicle =
    !!previous?.manually_created &&
    !!next?.manually_created &&
    previous.vehicle_id != null &&
    previous.vehicle_id === next.vehicle_id;

  if (!isSameManuallyCreatedVehicle || !next.sale_vehicle) return next;

  return {
    ...next,
    sale_vehicle: {
      ...next.sale_vehicle,
      retail_price: next.sale_vehicle.retail_price || previous?.sale_vehicle?.retail_price || 0,
      book_value: next.sale_vehicle.book_value || previous?.sale_vehicle?.book_value || 0,
    },
  };
};
